import { RegenerateTokenDto, RegenerateTokenDtoImpl } from './regeneratetokendto';
import { NoDataException } from '../../../utils/exceptions/nodataexistsexception';

export class RegenTokenBuilder {
    constructor(private regenTokenResponse: any) {

        if(regenTokenResponse === undefined)
        {
            throw new NoDataException("Regenerate Token data doesnt exists");
        }
    }

    buildAll(): RegenerateTokenDto {
        return this.parseRegenerateTokenDetailsResponse();
    }

    private parseRegenerateTokenDetailsResponse(): RegenerateTokenDto
    {
        let regenTokenDto = new RegenerateTokenDtoImpl();

        regenTokenDto.setRefreshToken(this.regenTokenResponse.refreshToken);
        regenTokenDto.setAccessToken(this.regenTokenResponse.accessToken);
        regenTokenDto.setExpiry(this.regenTokenResponse.expiry);
       
        return regenTokenDto;
    }
}




// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/dto/regeneratetoken/regentokenbuilder.ts